module.exports = __webpack_public_path__ + "static/media/update_footer.77e832bf.png";